<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="foreword" id="_idContainer006" role="doc-foreword">
<p class="pl-center">This book is dedicated to Casey...</p>
<p class="pl-center">I was blessed to help raise you and I’m absolutely delighted with the wonderful young woman you’ve become. You are a part of us...and always will be. You can’t get rid of me easily! Love you, kid.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?6e3f5464